export const OPEN_SHORTCUTS_EVENT = 'holzcom-open-shortcuts';
